export default [
  {
    path: '/app/home-page',
    name: 'HomePage',
    component: () => import('@/views/Admin/Home_page/Index.vue'),
    meta: {
      pageTitle: 'Kurumsal',
      breadcrumb: [
        {
          text: 'Anasayfa',
          active: true,
        },
      ],
      resource: 'ADMIN_HOME_PAGE',
      action: 'read',
    },
  },
]
